export * from "ce/constants/messages";
import {
  createMessage,
  APPLICATION_INVITE as CE_APPLICATION_INVITE,
  HEADER_TITLES as CE_HEADER_TITLES,
  INVITE_USERS_MESSAGE as CE_INVITE_USERS_MESSAGE,
  INVITE_USERS_PLACEHOLDER as CE_INVITE_USERS_PLACEHOLDER,
  INVITE_USERS_VALIDATION_EMAIL_LIST as CE_INVITE_USERS_VALIDATION_EMAIL_LIST,
  MEMBERS_TAB_TITLE as CE_MEMBERS_TAB_TITLE,
  SEARCH_USERS as CE_SEARCH_USERS,
  PAGE_SERVER_UNAVAILABLE_TITLE as CE_PAGE_SERVER_UNAVAILABLE_TITLE,
  INVITE_USERS_SUBMIT_SUCCESS as CE_INVITE_USERS_SUBMIT_SUCCESS,
  INVITE_USER_SUBMIT_SUCCESS as CE_INVITE_USER_SUBMIT_SUCCESS,
  EDITOR_PANE_TEXTS as CE_EDITOR_PANE_TEXTS,
} from "ce/constants/messages";

/*
  For self hosted CE, it displays the string "Appsmith Community v1.10.0".
 */
export const APPSMITH_DISPLAY_VERSION = (edition: string, version: string) =>
  `Appsmith ${version}`;

// Import modal
export const GENERIC_IMPORT_MODAL_TITLE = () => `Import`;
export const IMPORT_APP_PKG_MODAL_LABEL = () =>
  `Where would you like to import your application or package from?`;
export const UPLOADING_PACKAGE = () => "Uploading package";

// Test payload
export const TEST_PAYLOAD_VIEW_TITLE = () =>
  "Test values for function arguments";
export const TEST_PAYLOAD_VIEW_DESC = () =>
  "Define test values for function arguments.";
export const EMPTY_PAYLOAD_VIEW_TITLE = () => "Function arguments are empty";
export const EMPTY_PAYLOAD_VIEW_DESC = () =>
  "Define test values for the function arguments before executing. Pass an empty JSON {} if arguments are not required.";

// GAC begin
export const SHOW_LESS_GROUPS = () => `show less`;
export const SHOW_MORE_GROUPS = (count: number) => `show ${count} more`;
export const ADD_USERS = () => `Add users`;
export const ADD_GROUP = () => `Add group`;
export const ADD_ROLE = () => `Add role`;
export const SEARCH_PLACEHOLDER = () => `Search`;
export const SEARCH_GROUPS_PLACEHOLDER = () => `Search groups`;
export const SEARCH_ROLES_PLACEHOLDER = () => `Search roles`;
export const SEARCH_USERS_PLACEHOLDER = () => `Search users`;
export const ACL_DELETED_SUCCESS = () => `Deleted successfully`;
export const ACL_CLONED_SUCCESS = () => `Cloned successfully`;
export const SUCCESSFULLY_SAVED = () => `Saved successfully`;
export const ENTER_ENTITY_NAME = () => `Enter name`;
export const ENTER_ENTITY_DESC = () =>
  `Enter description (max characters: 140)`;
export const ACTIVE_ENTITIES = (entity: string) => `Active ${entity}s`;
export const ALL_ENTITIES = (entity: string) => `All ${entity}s`;
export const ADD_ENTITY = (entity: string) => `Add ${entity}`;
export const REMOVE_ENTITY = (entity: string) => `Remove ${entity}`;
export const REMOVE_USER = () => `Remove`;
export const ACL_DELETE = () => `Delete`;
export const ACL_CLONE = () => `Clone`;
export const ACL_RENAME = () => `Rename`;
export const ACL_EDIT = () => `Edit`;
export const ACL_EDIT_DESC = () => `Edit description`;
export const NO_USERS_MESSAGE = () => `There are no users added to this group`;
export const NO_ACTIVE_ENTITIES_MESSAGE = (
  entity: string,
) => `There are no ${entity}s assigned. Choose from the list of
${entity}s below to add them.`;
export const EMPTY_ENTITIES_MESSAGE = (entity: string) =>
  `There are no ${entity}s created.`;
export const NO_PERMISSION_TO_UNASSIGN = () =>
  `You do not have permission to unassign this role.`;
export const DEFAULT_ROLES_PILL = () => `D`;
export const DEFAULT_ROLES_TOGGLE_TEXT = () => `Default roles`;
export const BOTTOM_BAR_SAVE_MESSAGE =
  () => `These changes will affect the users ability to interact with various
aspects of the application. Are you sure?`;
export const BOTTOM_BAR_SAVE_BTN = () => `Save changes`;
export const BOTTOM_BAR_CLEAR_BTN = () => `Clear`;
export const ACL_INVITE_MODAL_TITLE = () => `Add users`;
export const ACL_INVITE_MODAL_MESSAGE = () =>
  `Add email id(s) and select group(s)`;
export const INVITE_USERS_MESSAGE = (cloudHosting?: boolean) =>
  cloudHosting
    ? createMessage(CE_INVITE_USERS_MESSAGE)
    : `Invite users or groups`;
export const INVITE_USERS_PLACEHOLDER = (isFreeInstance?: boolean) =>
  isFreeInstance
    ? createMessage(CE_INVITE_USERS_PLACEHOLDER)
    : `Enter email address(es) or group(s)`;
export const INVITE_USERS_VALIDATION_EMAIL_LIST = (isFreeInstance?: boolean) =>
  isFreeInstance
    ? createMessage(CE_INVITE_USERS_VALIDATION_EMAIL_LIST)
    : `Invalid email address(es) or group(s) found`;
export const MEMBERS_TAB_TITLE = (length: number, isFreeInstance?: boolean) =>
  isFreeInstance
    ? createMessage(CE_MEMBERS_TAB_TITLE, length)
    : `Users / User Groups (${length})`;
export const SEARCH_USERS = (isFreeInstance?: boolean) =>
  isFreeInstance
    ? createMessage(CE_SEARCH_USERS)
    : `Search for users or groups`;
export const INVITE_USERS_SUBMIT_SUCCESS = (isFreeInstance?: boolean) =>
  isFreeInstance
    ? createMessage(CE_INVITE_USERS_SUBMIT_SUCCESS)
    : `The users/groups have been invited successfully`;
export const INVITE_USER_SUBMIT_SUCCESS = (isFreeInstance?: boolean) =>
  isFreeInstance
    ? createMessage(CE_INVITE_USER_SUBMIT_SUCCESS)
    : `The user/group have been invited successfully`;
export const APPLICATION_INVITE = (name: string, isFreeInstance?: boolean) =>
  isFreeInstance ? CE_APPLICATION_INVITE(name) : "Application invite";
export const EVENT_GROUP_ADD_USER_TOP_BAR = () =>
  "Group details page > Top bar";
export const EVENT_GROUP_ADD_USER_EMPTY_STATE = () =>
  "Group details page > Users tab > Empty state";
export const EVENT_GROUP_INVITE_USER_TOP_BAR = () =>
  "Group details page > Top bar > Add user modal";
export const EVENT_GROUP_INVITE_USER_EMPTY_STATE = () =>
  "Group details page > Users tab > Empty state > Add user modal";
export const EVENT_USER_INVITE = () => "Users page > Add user modal";
export const EVENT_USERS_PAGE = () => "Users page";
export const EVENT_USER_ROLES_TAB = () => "User details page > Roles tab";
export const EVENT_USER_GROUPS_TAB = () => "User details page > Groups tab";
export const EVENT_GROUP_ROLES_TAB = () => "Group details page > Roles tab";
// GAC end

// Audit logs begin
export const TRY_AGAIN_WITH_YOUR_FILTER = () => "Try again with your filter";
export const LOADING = () => "Loading...";
export const RESOURCE_ID_LABEL = () => "Resource ID";
export const RESOURCE_ID_PLACEHOLDER = () => "Type or paste resource id";
export const EVENTS_LABEL = () => "Events";
export const EVENTS_PLACEHOLDER = () => "Select events";
export const USERS_LABEL = () => "Users";
export const USERS_PLACEHOLDER = () => "Select users";
export const DATE_RANGE_LABEL = () => "Date range";
export const CLEAR_ALL = () => "Clear all";
export const ON_COPY_CONTENT = (input: string) =>
  `Audit log with id [${input}] copied to clipboard`;
export const EVENT_DESCRIPTION_LABEL = () => "Event description";
export const USER_LABEL = () => "User";
export const DATE_LABEL = () => "Date";
export const REFRESH = () => "Refresh";
// Audit logs end

// Branding
export const ADMIN_BRANDING_SETTINGS_TITLE = () => "Branding";
export const ADMIN_BRANDING_SETTINGS_SUBTITLE = () =>
  "Set your organization's logo and brand colors.";

// Billing
export const ADMIN_BILLING_SETTINGS_TITLE = () => "License & plans";
export const ADMIN_BILLING_SETTINGS_SUBTITLE = () =>
  "View customer portal to view usage and billing related information, and to manage your subscription.";
export const NO_ACTIVE_SUBSCRIPTION = () => "No active subscription";
export const LICENSE_GET_STARTED_HEADING = () =>
  "How do you want to get started?";
export const LICENSE_GET_STARTED_MESSAGE = () =>
  "Our free plan is great for solo developers and small teams.";
export const LICENSE_GET_STARTED_MESSAGE_NEXT = () =>
  "If you are trialing one of our paid plans and have a license key, choose Paid.";
export const LICENSE_KEY_FORM_INPUT_LABEL = () =>
  "If you already have a license, please enter the key to continue";
export const LICENSE_KEY_MODAL_INPUT_LABEL = () => "Enter license key";
export const LICENSE_KEY_CTA_LABEL = () => "Don't have a license key?";
export const TRIAL_EXPIRY_WARNING = (gracePeriod: number, suffix: string) =>
  `Your trial will expire in ${gracePeriod} ${suffix}.`;
export const CONTINUE_USING_FEATURES = () =>
  `Upgrade to continue using all the features.`;
export const NON_ADMIN_USER_TRIAL_EXPIRTY_WARNING = () =>
  `Contact your administrator to upgrade and continue using Appsmith.`;
export const TOTAL_USERS_MESSAGE = () => `Total users`;
export const NUMBER_OF_SELF_HOSTED_USERS = () =>
  ` Number of users on the self-hosted instance`;
export const BILLING_AND_USAGE = () => `Billing & usage`;
export const OPEN_CUSTOMER_PORTAL = () => `Open customer portal`;
export const BE_WELCOME_MESSAGE = () => "Welcome to Appsmith Business Plan";
export const BE_WELCOME_MESSAGE_ENTERPRISE = () =>
  "Welcome to Appsmith Enterprise Plan";
export const BE_TRIAL_BANNER_EXPIRY_MESSAGE = (
  gracePeriod: number,
  suffix: string,
) => `Trial ends in <span>${gracePeriod}</span> ${suffix}`;
export const UPGRADE_NOW = () => `Upgrade now`;
export const CLOSE = () => `Close`;
export const UPGRADE_TO_BUSINESS = () => `Upgrade to Business`;
export const ADD_KEY = () => `Add key`;
export const ACTIVATE_INSTANCE = () => `Activate instance`;
export const GET_TRIAL_LICENSE = () => `Get trial license`;
export const REQUIRED_LICENSE_KEY = () => `License key is required`;
export const INVALID_LICENSE_KEY = () => `License key is invalid`;
export const YOUR_LICENSE_KEY = () => `Your license key`;
export const UPDATE_LICENSE = () => `Update license`;
export const PREV_LICENSE_INVALID = () =>
  `The previous license will be invalid`;
export const ACTIVATE = () => `Activate`;
export const PASTE_LICENSE_KEY = () => `Paste your license key here`;
export const LICENSE_EXPIRY_DATE = (date: string) => `Valid until: ${date}`;
export const UPDATE = () => "Update";
// cloud billing - billing page
export const CB_BILLING_TITLE = () => "Billing";
export const CB_BILLING_PLANS_DESCRIPTION = () => "Choose a plan to start with";
export const CB_BILLING_DETAILS_DESCRIPTION = () =>
  "All your plan details in once place";
export const BILLING_TRIAL_PLAN_CALLOUT = (numberOfDays: string) =>
  `Your Business plan trial ends in ${numberOfDays}, please upgrade to continue to get business plan benefits.`;
export const TEAM_BILLING_TRIAL_PLAN_CALLOUT = (numberOfDays: string) =>
  `Your Team plan trial ends in ${numberOfDays}, please upgrade to continue to get team plan benefits.`;
export const CONTACT_US_CTA = () => "Contact us";
export const CURRENT_PLAN_CTA = () => `Current plan`;
export const UPGRADE_TEXT = () => `Upgrade`;
export const UPGRADE_PLAN_MODAL_LOADING_TITLE = () =>
  `Upgrading to business plan`;
export const UPGRADE_PLAN_MODAL_LOADING_TITLE_AI = () =>
  `Upgrading to team plan`;
export const UPGRADE_PLAN_MODAL_TITLE = () => `Business Plan`;
export const UPGRADE_PLAN_MODAL_TITLE_AI = () => `Team Plan`;
export const UPGRADE_PLAN_MODAL_CALLOUT = () =>
  `Upgrading applies to every active member of this organisation. If new people join or inactive members become active, they'll be added to your next bill.`;
export const SUPPORT_EMAIL = () => "support@appsmith.com";
export const REACH_OUT = () => "Have any questions? Please reach out to ";
export const CURRENCY_FORMAT = (price: number) =>
  price < 0 ? `-$${Math.abs(price)}` : `$${price}`;
export const SEAT_BASED_BILLING_PRICE_PER_MONTH_TEXT = (price: number) =>
  `${createMessage(CURRENCY_FORMAT, price)} seat/month`;
export const SEAT_BASED_BILLING_TOTAL_SEATS_TEXT = (totalSeats: number) =>
  `${totalSeats} seats`;
export const SEAT_BASED_BILLING_RENEWAL_DATE_TEXT = (endDate: string) =>
  `Renews on ${endDate}`;
export const SEAT_BASED_PRICING_ENV_DATA_FETCH_ERROR = () =>
  `Unable to fetch seat based pricing env data, please try again.`;
export const UPGRADE_TO_ENTERPRISE_CTA = () => `Upgrade to Enterprise`;
export const ENTERPRISE_CONTACT_MESSAGE_INTERCOM = () =>
  `Hello team, we are interested in the enterprise plan of Appsmith. Could you connect us to someone from the sales team?`;
export const SEAT_BASED_BILLING_MANAGE_YOUR_BILLING_TEXT = () =>
  `To view invoices or manage your subscription`;
export const INVOICE_CARD_TITLE = () => `Upcoming invoice`;
export const INVOICE_CARD_DESCRIPTION = (date: string) => `On ${date}`;
export const INVOICE_CARD_INVOICE_ITEMS = {
  description: () => `Description`,
  quantity: () => `Quantity`,
  unit_price: () => `Unit price`,
  amount: () => `Amount`,
  subtotal: () => `Subtotal`,
  total: (date: string) => `Total amount due (next charge on ${date})`,
};
export const SEAT_BASED_BILLING_PLAN_TEXT = () => `Plan: Business`;
export const SEAT_BASED_BILLING_PLAN_TEXT_AI = () => `Plan: Team`;
export const MANAGE_YOUR_BILLING = () => `Manage your billing`;
export const STRIPE_LINK_TEXT = () => `Stripe dashboard`;
export const BUSINESS_PLAN_DESCRIPTION = (price: number) =>
  `${createMessage(CURRENCY_FORMAT, price)} seat/month`;
export const TEAM_PLAN_DESCRIPTION = (price: number) =>
  `${createMessage(CURRENCY_FORMAT, price)} / month per user`;

export const LICENSE_ERROR_TITLE = () => `No active subscription`;
export const LICENSE_ERROR_DESCRIPTION = () =>
  `Your instance is currently inactive. Please contact your instance administrator to reactivate the instance.`;
export const VISIT_CUSTOMER_PORTAL = () => `Get it now`;
export const VISIT_PORTAL = () => `Visit portal`;

export const LICENSE_REFRESHED_SUCCESSFULLY = () =>
  `Your license has been refreshed successfully`;
export const TRIAL_LICENSE_ACTIVATED_SUCCESSFULLY = () =>
  `Your trial license has been activated successfully`;
export const NOT_AVAILABLE = () => `Not available`;
export const ACTIVE = () => `Active`;
export const TRIAL = () => `Trial`;
export const CUSTOMER_PORTAL = () => `Customer portal`;
export const LICENSE_KEY = () => `License key`;
export const ALREADY_UPGRADED = () => `Already upgraded?`;
export const PAYMENT_FAILED = () => `Your most recent payment has failed.`;
export const PAYMENT_FAILED_TEXT_SELF_SERVE = (count: number, suffix: string) =>
  `Your most recent payment has failed. Update your payment methods or your instances will stop working in ${count} ${suffix}.`;
export const PAYMENT_FAILED_TEXT_SALES = () =>
  `Your last payment is overdue. Please clear it soon to avoid any service disruptions.`;
export const ENTERPRISE = () => `Enterprise`;
export const SELF_SERVE = () => `Business`;
export const AIRGAPPED = () => `Airgapped`;
export const FREE = () => `Free`;
export const VISIT_PORTAL_CTA = () => `Visit portal`;
export const SUBMIT_BUTTON = () => "Submit";
export const LICENSE_FORM_DESCIPTION = () =>
  "Your previous license will be invalid";
export const GET_STARTED = () => `Get started`;
export const FREE_SUBTEXT = () => "Self-host our free plan";
export const PAID = () => `Paid`;
export const PAID_SUBTEXT = () => "Self-host our paid plans";
export const ADD_LICENSE = () => "Add license";
export const PLAN = () => "Plan";
export const LICENSE = () => "License";
export const REMOVE_LICENSE_KEY = () => `Remove license key`;
export const REMOVE = () => `Remove`;
export const REMOVE_LICENSE_KEY_MODAL_TEXT = () =>
  "If you remove your license key, you will lose access to all paid features. To learn more about how this will impact your instance, refer to our documentation.";
export const REMOVE_LICENSE_KEY_MODAL_SUBTEXT = () =>
  `We will enable form login by default for all users and we strongly recommend enabling email verification for enhanced security measures.`;
export const LEARN_MORE = () => "Learn more";
export const CONFIRM = () => "Confirm";
export const Name = () => "Name";
export const START_DATE = () => "Subscription start date";
export const END_DATE = () => "Subscription end date";
export const EMAIL = () => "Registered email ID";
export const MANAGE = () => "Manage plans";
export const PASTE_LICENSE = () => "Paste your license key here to activate.";
export const DONT_HAVE_LICENSE = () => "Don't have a license?";
export const GET_ONE_NOW = () => "Get one now.";
export const DOWNGRADE_CALLOUT_TEXT_PAID = () =>
  "Your license key is no longer valid. Contact us to continue using all the features.";
export const TRIAL_EXPIRED_TEXT = () =>
  "Your trial has expired. Upgrade to continue using all the features.";
export const PAID_EXPIRED_TEXT = () =>
  "Your license key is no longer valid. Get a new license to continue using all the features.";
export const DOWNGRADE_CALLOUT_TEXT_TRIAL = () =>
  "Your trial license has expired. Upgrade to continue using all the features.";
export const DOWNGRADE_CALLOUT_SUBTEXT_1_ACTIVE = () =>
  "If you decide to downgrade, you will lose access to the features that are exclusive to your current plan. To learn more about how this will impact your instance, refer to our documentation.";
export const DOWNGRADE_CALLOUT_SUBTEXT_1_EXPIRED = () =>
  "If you decide to downgrade, you will lose access to all paid features. To learn more about how this will impact your instance, refer to our documentation.";
export const DOWNGRADE_CALLOUT_SUBTEXT_2 = () =>
  "Additionally, we will enable form login by default for all users and we strongly recommend enabling email verification for enhanced security measures.";
export const DOWNGRADE_CALLOUT_TEXT = () =>
  "Your license key is valid. However, please note that your new key corresponds to a lower tier plan than your current plan.";
export const LICENSE_EXPIRED_HEADING_TRIAL = () => "Continue using Appsmith";
export const LICENSE_TRIAL_EXPIRED_COMMMUNITY_DOWNGRADE = () =>
  "Downgrade to our free plan";
export const LICENSE_TRIAL_EXPIRED_CONTINUE = () =>
  "Continue with our paid plan";
export const LICENSE_PAID_EXPIRED_CONTINUE = () =>
  "Start again with our paid plan";
export const LICENSE_EXPIRED_HEADING_PAID = () => "Restart with Appsmith";
export const CONTACT_US = () => "Contact us";
export const NEED_NEW_LICENSE = () => "Need a new license?";
export const KEY = () => `Key`;
export const MIGRATIONS = () => `Migrations`;
export const MIGRATIONS_TEXT = () =>
  `We are updating your instance. Please allow us some time to complete the migration.`;
export const MIGRATIONS_ERROR_TEXT = () =>
  `Updating your instance failed. Please restart the server again for the license changes to take place.`;
export const DOWNGRADE = () => `Downgrade`;
export const CURRENT_PLAN = () => `Current plan`;
export const VISIT_DOCS = () => `Visit docs`;

// Welcome form EE
export const WELCOME_FORM_SUBMIT_LABEL = () => "Next";

// Auth pages
export const SIGNUP_PAGE_TITLE = () => `Create your account`;
export const SIGN_IN_TO_ORG = () => `Sign in to your organisation`;
export const SIGN_IN_TO_ORG_PAGE_SUBTITLE = () => `Enter your organisation URL`;
export const SIGN_IN_TO_ORG_PAGE_URL_PLACEHOLDER = () => `your-organisation`;
export const SIGN_IN_TO_ORG_PAGE_SUBMIT_BUTTON = () => `Continue`;
// error pages
export const PAGE_SERVER_UNAVAILABLE_TITLE = (cloudHosting: boolean) => {
  if (cloudHosting) {
    return CE_PAGE_SERVER_UNAVAILABLE_TITLE(cloudHosting);
  } else {
    return "Server unavailable";
  }
};

// Environments start
export const ENVIRONMENT_FILTER_DISABLED_TOOLTIP = (
  PluginName = "This",
  envName = "staging",
) =>
  `Production and ${envName.toLowerCase()} configurations are the same since ${PluginName.toLowerCase()} datasource doesn't support environments.`;
export const ENV_INFO_MODAL_CHECKBOX_LABEL = () =>
  "I understand, don't tell me again.";
export const ENV_INFO_MODAL_HEADER = () =>
  "All application changes will be deployed";
export const ENV_INFO_MODAL_DESCRIPTION = () =>
  "To isolate application changes between Staging and Production, connect your apps to a Git repo and create branches for Staging and Production.";
export const ENV_INFO_MODAL_DOCUMENATION_LINK_TEXT = () =>
  "Learn more about environments";
export const ENV_INFO_CALLOUT_TOOLTIP = () =>
  "Widgets, layouts, results from queries and code";
export const ENV_INFO_CALLOUT_CONTENT_1 = () => "End-users will see all ";
export const ENV_INFO_CALLOUT_CONTENT_2 = () => "application-level";
export const ENV_INFO_CALLOUT_CONTENT_3 = () =>
  " changes irrespective of whether you made them while connected to any datasource environment.";
export const ENV_INFO_MODAL_DISMISS_ACTION = () => "Don't show me again";
export const MANAGE_ENV_TITLE = () =>
  "List of datasource environments within your workspace";
export const MANAGE_ENV_CREATE_MODAL_TITLE = () => "Create new environment";
export const MANAGE_ENV_EDIT_MODAL_TITLE = () => "Update environment";
export const MANAGE_ENV_MODAL_INPUT_LABEL = () => "Environment Name";
export const MANAGE_ENV_MODAL_DELETE_DESC = (
  envName: string,
  workspaceName: string,
  configuredDatasources: number,
) =>
  `Deleting ${envName} environment from ${workspaceName} will permanently remove ${envName.toLowerCase()} configurations for all ${configuredDatasources} datasources.`;
export const MANAGE_ENV_MODAL_INPUT_PLACEHOLDER = () =>
  "Enter environment name";
export const MANAGE_ENV_ERROR_SP_CHAR_MESSAGE = () =>
  "Environment cannot contain any special characters except “_”";
export const MANAGE_ENV_ERROR_START_WITH_SP_CHAR_NUM_MESSAGE = () =>
  "Environment name cannot start with a number or “_” character";
export const MANAGE_ENV_ERROR_DUPLICATE_NAME_MESSAGE = () =>
  "You cannot have two environments with the same name.";
export const ENV_WALKTHROUGH_A_TITLE = () => "Datasource environments";
export const ENV_WALKTHROUGH_A_BODY = () =>
  `Appsmith now supports having different environment configurations for your datasources.\n\nYou can use this dropdown to select the active environment for your application.`;
export const ENV_WALKTHROUGH_A_FOOTER_TEXT = () =>
  "Step 2: Configure your environment";
export const ENV_WALKTHROUGH_A_FOOTER_BTN_TEXT = () => "Next";
export const ENV_WALKTHROUGH_B_TITLE = () => "Configure environments";
export const ENV_WALKTHROUGH_B_BODY = () =>
  `Select the desired environment option from the selector.\n\nFill in the relevant information to configure the environment for your datasource and save.`;
// Environments end

// Provisioning begin
export const PROVISIONING_TITLE = () => "User provisioning & Group sync";
export const PROVISIONING_DESC = () =>
  "Supports your IdP via SCIM for now. Other provisioning specifications coming soon.";
export const SCIM_CARD_TITLE = () =>
  "System for Cross-domain Identity Management";
export const SCIM_CARD_SUB_TEXT = () =>
  "Configure your identity providers like Okta, Azure Active Directory and others to manage authorization and access in Appsmith.";
export const SCIM_CALLOUT_HEADING = () => "How to setup SCIM";
export const SCIM_CALLOUT_LIST = [
  "Enable SAML on Appsmith before you input SCIM config details.",
  "See our SCIM config documentation below to get set-up instructions for supported providers.",
  "Copy the endpoint URL and the API key right away into your IdP's console.",
];
export const CONNECTION_ACTIVE = () => "Connection Active";
export const CONNECTION_INACTIVE = () => "Connection Inactive";
export const OPEN_DOCUMENTATION = () => "Open documentation";
export const SCIM_API_ENDPOINT = () => "SCIM API endpoint";
export const SCIM_API_ENDPOINT_HELP_TEXT = () =>
  "Paste this URL in your IdP service providers console.";
export const API_KEY_TO_SETUP_SCIM = () => "API key to setup SCIM";
export const COPY_PASTE_API_KEY_CALLOUT = () =>
  "Copy and paste your API key into your IdP's console right away. You can't do this later.";
export const GENERATE_API_KEY = () => "Generate API key";
export const RECONFIGURE_API_KEY = () => "Re-configure API key";
export const DISABLE_SCIM = () => "Disable SCIM";
export const LAST_SYNC_MESSAGE = (lastUpdated: string) =>
  `Last sync ${lastUpdated ? `happened ${lastUpdated} ago` : "never happened"}`;
export const DISABLE_SCIM_MODAL_TITLE = () => "Disable SCIM config";
export const DISABLE_SCIM_MODAL_BUTTON = () => "Disable this SCIM config";
export const RADIO_GROUP_HEADING = () =>
  "If you would still like to disable this config, choose one of the below options";
export const DISABLE_SCIM_MODAL_CONFIRMATION = () => "I understand and confirm";
export const CONNECTION_INACTIVE_CALLOUT_ON_MODAL = () =>
  "This connection will be disabled. Any updates in your IdP will not sync with Appsmith.";
export const KEEP_PROVISIONED_RESOURCES = () =>
  "Keep users and groups from this connection";
export const REMOVE_PROVISIONED_RESOURCES = () =>
  "Remove users and groups from this connection";
export const KEEP_RESOURCES_SUB_TEXT_ON_MODAL = () =>
  "This will keep all users and groups linked to Appsmith via this SCIM connection, but any updates in your IdP provider will not sync with Appsmith";
export const REMOVE_RESOURCES_SUB_TEXT_ON_MODAL = () =>
  "This will permanently remove all users and groups linked to Appsmith from this SCIM connection.";
export const DISABLE_SCIM_WARNING = () =>
  "We strongly advise disabling provisioning in your IdP to remove users from Appsmith. This step ensures seamless user management and avoids potential conflicts while re-configuring SCIM with Appsmith in the future.";
export const RECONFIGURE_API_KEY_MODAL_TITLE = () => "Re-configure API key";
export const RECONFIGURE_API_KEY_MODAL_CONTENT = () =>
  "Regenerating your API key will invalidate the current key, leading to API failures. Please proceed with key regeneration only if you intend to replace your existing key on your IdP. Exercise caution to avoid disruption of services relying on the current API key.";
export const RECONFIGURE_API_KEY_MODAL_CANCEL_BUTTON = () => "Cancel";
export const RECONFIGURE_API_KEY_MODAL_SUBMIT_BUTTON = () => "Re-configure";
export const LOGO_DIFFERENT_TOOLTIP = () =>
  "Logo is different from the brand logo set.";
export const RESET_LOGO_TOOLTIP = () => "Reset logo";
// Provisioning end

// Modules start
export const PACKAGE_EMPTY_STATE_MSG = () => "No modules in this package yet.";
export const UI_MODULE_EMPTY_STATE_MSG = () =>
  "No UI modules left in this package.";
export const PACKAGE_EMPTY_STATE_HELP = () =>
  "Learn more about Appsmith Reusability.";
export const PACKAGE_EMPTY_STATE_CTA = () => "New Module";
export const SEARCH_APPS_PACKAGES_AND_WORKFLOWS = () =>
  "Search for apps, packages or workflows";
export const SEARCH_APPS_AND_PACKAGES = () => "Search for apps or packages";
export const WORKSPACE_ACTION_BUTTON = () => "Create new";
export const NEW_PACKAGE = () => "Package";

export const FETCH_PACKAGES_ERROR = () => "Failed to fetch Packages";
export const FETCH_PACKAGE_ERROR = () => "Failed to fetch Package";
export const CREATE_PACKAGE_ERROR = () => "Failed to create package";
export const MODULES_TITLE = () => "Modules";
export const ADD_MODULE_TOOLTIP = () => "Add a new module";
export const EMPTY_MODULES_MSG = () => "No modules to display.";
export const NEW_MODULE_BUTTON = () => "New module";
export const RENAME_PACKAGE_TOOLTIP = () => "Rename package";
export const ADD_QUERY_BUTTON = () => "Add query";
export const ADD_JS_BUTTON = () => "Add JS Module";
export const PACKAGE_NAME_CANT_BE_EMPTY = () => "Package name can't be empty";
export const ERROR_DELETING_PACKAGE = () => "Error while deleting Package";
export const INVALID_INPUT_NAME = () =>
  "Input names can only contain alphanumeric and should start with an alphabet";
export const UNIQUE_INPUT_NAME = () => "Input name should be unique.";
export const MODULE_INSTANCE_EMPTY_INPUT = () =>
  "No inputs parameters defined for this query.";
export const MODULE_INSTANCE_RENAME_ERROR = (name: string) =>
  `Unable to update module instance name to ${name}`;
export const NEW_REUSABLE_QUERY_BUTTON_TEXT = () => "New reusable query";
export const NEW_REUSABLE_API_BUTTON_TEXT = () => "New reusable API";
export const CONVERT_MODULE_CTA_TEXT = () => "Create module";
export const CONVERT_ENTITY_UNPUBLISHED_CHANGES_WARN = () =>
  "The package has unsaved changes. Please publish it first.";
export const CANNOT_CREATE_MODULE_WARN = () =>
  "You do not have permission to add module into this package";
export const CANNOT_CONVERT_TAGGED_MODULE_WARN = () =>
  "This feature is not available for tagged version of packages";
export const GO_TO_MODULE = () => "Go to Module";
export const DISABLED_GO_TO_GIT_MODULE_REASON = () =>
  "This feature is not available for tagged version of packages";
export const IMPORT_PACKAGE = () => "Import package";
export const IMPORT_PACKAGE_SUCCESS = () => "Package imported successful";
export const UPDATE_PACKAGE = () => "Update package";
export const MISSING_PACKAGE_OR_MODULE = () =>
  "There are missing packages or modules, preventing the application from behaving normally.";
export const OPEN_DEBUGGER_CTA = () => "Open Debugger";
export const PACKAGE_UPDATE_VIA_IMPORT_SETTING = {
  settingHeader: () => "Update through file import",
  settingDesc: () => "Update package by importing file",
  settingLabel: () => "Import",
  settingContent: () =>
    "This action will override your existing package. Please exercise caution while selecting the file to import.",
  settingActionButtonTxt: () => "Import",
  disabledForGit: () =>
    "This feature is not supported for packages connected to Git version control. Please use git pull to update and sync your app.",
};
export const ERROR_IMPORT_PACKAGE = () => "Error importing package";
export const PULLING_PACKAGE = () => "Updating package references";
export const PACKAGE_PULL_ERROR = () =>
  "Something went wrong while updating package references. Please reload the page to try again.";
export const START_SWITCH_ENVIRONMENT_FOR_PACKAGE = (environment: string) =>
  `Switching your environment to ${environment.toLowerCase()}`;
export const UPDATE_MODULE_INPUT_ERROR = () => "Failed to update inputs";
export const SKIP_TO_PACKAGE = () => "Go to package";
export const RECONNECT_MISSING_DATASOURCE_CREDENTIALS_PKG_DESCRIPTION = () =>
  "Fill these with utmost care as the package will not behave normally otherwise";
export const PACKAGE_IMPORT_SUCCESS = () => `Your package is ready to use.`;
export const MODULE_INSTANCE_COPY_SUCCESS = (
  moduleInstanceName: string,
  pageName: string,
) => `${moduleInstanceName} copied to page ${pageName} successfully`;
export const MODULE_INSTANCE_COPY_ERROR = (moduleInstanceName: string) =>
  `Error while copying ${moduleInstanceName}`;
export const MODULE_INSTANCE_MOVE_SUCCESS = (
  moduleInstanceName: string,
  pageName: string,
) => `${moduleInstanceName} moved to page ${pageName} successfully`;
export const MODULE_INSTANCE_MOVE_ERROR = (moduleInstanceName: string) =>
  `Error while moving ${moduleInstanceName}`;
export const MODULE_SETUP_FAILURE = () => `Failed setting up modules.`;
export const PRIVATE_ENTITY_DEPRECATE = () =>
  "Private queries and JS objects are no longer needed, as you can access any module within the package directly. Existing ones will still work until deleted.";
export const NO_JS_INSTANCE_PARAMS = () =>
  "No parameters defined for this function.";
export const MODULE_CYCLIC_REFERENCE_ERROR = (path: string) =>
  `Cyclic reference detected. \n Please check the dependency path to resolve this. \n ${path}`;
export const NEXT_PUBLISH_VERSION = (version: string) => `Publish v${version}`;
export const PACKAGE_PUBLISH_SUCCESS = (version: string) =>
  `Package published successfully (v${version})`;
export const PACKAGE_PUBLISH_SUCCESS_SIMPLE = () =>
  "Package published successfully";
export const PACKAGES_CONTROL_TITLE = () => "Package versions used in this app";
export const PACKAGES_CONTROL_DESCRIPTION = () =>
  "Configure the version for each package used";
export const EMPTY_PACKAGE_CONTROL_TITLE = () =>
  "Add modules to configure package versions";
export const EMPTY_PACKAGE_CONTROL_DESCRIPTION = () =>
  "No packages in use yet. To manage package versions, add a Query or JS Module from the editor.";
export const MODULE_INSTANCE_PACKAGE_UPGRADING_STATUS = () =>
  "The package this module belongs to is being updated. Please wait until the reference update is complete.";
export const CONSUMED_PACKAGE_CHANGE_VERSION_ERROR = () =>
  "Failed to change package version";
export const PACKAGE_RELEASE_VERSION = () => "Release version";
export const CREATE_PACKAGE_MODAL_TITLE = () => "Create package";
export const CREATE_PACKAGE_MODAL_UI_PACKAGE_TITLE = () => "UI Package";
export const CREATE_PACKAGE_MODAL_UI_PACKAGE_DESCRIPTION = () =>
  "Reusable widgets that could be bound to queries and JS and used across workspace";
export const CREATE_PACKAGE_MODAL_CODE_PACKAGE_TITLE = () => "Code Package";
export const CREATE_PACKAGE_MODAL_CODE_PACKAGE_DESCRIPTION = () =>
  "Queries and JS that can be reused across workspace";
// Modules end

//Worflows start
export const WORKFLOWS = () => "Workflows";
export const SEARCH_APPS_AND_WORKFLOWS = () => "Search for apps or workflows";
export const NEW_WORKFLOW = () => "Workflow";
export const FETCH_WORKFLOW_ERROR = () => "Failed to fetch Workflow";
export const CREATE_WORKFLOW_ERROR = () => "Failed to create workflow";
export const RENAME_WORKFLOW_TOOLTIP = () => "Rename workflow";

export const WORKFLOW_SETTINGS_PANE_TITLE = () => "Workflow settings";
export const GENERAL_SETTINGS_WORKFLOW_SECTION_HEADER_DESC = () =>
  "Workflow name, icon and share";
export const GENERAL_SETTINGS_WORKFLOW_NAME_LABEL = () => "Workflow name";
export const GENERAL_SETTINGS_WORKFLOW_NAME_EMPTY_MESSAGE = () =>
  "Workflow name cannot be empty";
export const GENERAL_SETTINGS_WORKFLOW_NAME_SPECIAL_CHARACTER_ERROR = () =>
  "Only alphanumeric or '-()' are allowed";
export const GENERAL_SETTINGS_WORKFLOW_ICON_LABEL = () => "Workflow icon";

export const TRIGGER_SETTINGS_SECTION_HEADER = () => "Triggers";
export const TRIGGER_SETTINGS_SECTION_HEADER_DESC = () =>
  "Webhook and schedule triggers";
export const TRIGGER_SETTINGS_SECTION_CONTENT_HEADER = () => "Trigger settings";
export const WEBHOOK_TRIGGER_SWITCH_LABEL = () => "Webhook trigger";
export const WEBHOOK_TRIGGER_SWITCH_DESC = () =>
  "Copy the endpoint URL to configure the webhook trigger.";
export const WEBHOOK_TRIGGER_TOKEN_WARNING = () =>
  "Save these credentials right away. This won't be visible again for security.";
export const WEBHOOK_TRIGGER_TOKEN_LABEL = () =>
  "Use POST method to configure webhook.";
export const TRIGGER_SETTINGS_SCHEDULE_SECTION_HEADER = () =>
  "Scheduled trigger";
export const TRIGGER_SETTINGS_SCHEDULE_SECTION_DESC = () =>
  "Add a schedule triggers that run workflows automatically at regular intervals";
export const WORKFLOW_SCHEDULE_TIMEZONE_SELECT_LABEL = () => "Timezone";
export const WORKFLOW_SCHEDULE_INPUT_MINUTE_LABEL = () => "Minute";
export const WORKFLOW_SCHEDULE_INPUT_HOUR_LABEL = () => "Hour";
export const WORKFLOW_SCHEDULE_INPUT_DAY_OF_MONTH_LABEL = () => "Day of month";
export const WORKFLOW_SCHEDULE_INPUT_MONTH_LABEL = () => "Month";
export const WORKFLOW_SCHEDULE_INPUT_DAY_OF_WEEK_LABEL = () => "Day of week";
export const WORKFLOW_SCHEDULE_INPUT_MINUTE_PLACEHOLDER = () => "0-59";
export const WORKFLOW_SCHEDULE_INPUT_HOUR_PLACEHOLDER = () => "0-23";
export const WORKFLOW_SCHEDULE_INPUT_DAY_OF_MONTH_PLACEHOLDER = () => "0-31";
export const WORKFLOW_SCHEDULE_INPUT_MONTH_PLACEHOLDER = () => "0-12";
export const WORKFLOW_SCHEDULE_INPUT_DAY_OF_WEEK_PLACEHOLDER = () => "0-7";
export const WORKFLOW_SCHEDULE_INPUT_TOOLTIP = () =>
  "Use : (*) for all values, (,) as value separator, (-) value range, (/) step values.";
export const WORKFLOW_SCHEDULE_INPUT_VALIDATION_REGEX_ERROR = () =>
  "Invalid format.";
export const WORKFLOW_SCHEDULE_INPUT_VALIDATION_REQUIRED_ERROR = () =>
  "Required field";
export const WORKFLOW_SCHEDULE_TRANSFORMATION_FAILED = () =>
  "Invalid CRON format, cannot evaluate.";
export const WORKFLOW_SCHEDULE_FORM_CTA_SUBMIT = () => "Save schedule";
export const WORKFLOW_RUN_HISTORY_PANE_TRIGGER_LABEL = () => "Run History";
export const WORKFLOW_RUN_HISTORY_PANE_TRIGGER_SHOW_TOOLTIP = () =>
  "Show previous runs of this workflow";
export const WORKFLOW_RUN_HISTORY_PANE_TRIGGER_HIDE_TOOLTIP = () =>
  "Hide previous runs of this workflow";
export const WORKFLOW_RUN_HISTORY_PANE_TRIGGER_TAB = () => "Run History";
export const WORKFLOW_REGENERATE_MODAL_DESC = () =>
  "Re-generating your endpoint url will invalidate the current one. Only proceed with regeneration if you plan to replace your existing configurations everywhere.";
export const WORKFLOW_REGENERATE_CTA = () => "Re-generate endpoint URL";
export const WORKFLOW_COPY_CURL_CTA = () => "Copy cURL";
export const WORKFLOW_COPY_CONFIRM_CTA = () => "Copied to clipboard";
export const WORKFLOW_RUN_HISTORY_LOADING_TEXT = () =>
  "Workflow is executing, fetching logs...";
export const WORKFLOW_RUN_HISTORY_TAB_LABEL_ALL_RUNS = () => "All Runs";
export const WORKFLOW_RUN_HISTORY_TAB_LABEL_FAILED_RUNS = () => "Failed Runs";

export const WORKFLOW_APPROVAL_RESOLUTION_FORM_TITLE = () =>
  "Resolve the request";
export const WORKFLOW_APPROVAL_RESOLUTION_FORM_SELECT_LABEL = () =>
  "Select a resolution";
export const WORKFLOW_APPROVAL_RESOLUTION_FORM_SELECT_PLACEHOLDER = () =>
  "Select a resolution";
export const WORKFLOW_APPROVAL_RESOLUTION_FORM_METADATA_LABEL = () =>
  "Response payload";
export const WORKFLOW_APPROVAL_RESOLUTION_FORM_METADATA_PLACEHOLDER = () =>
  "Metadata";
export const WORKFLOW_APPROVAL_RESOLUTION_FORM_CTA_SUBMIT = () => "Resolve";
export const GENERATE_APPROVAL_PAGE_FORM_TITLE = () =>
  "Configure approval requests";
export const GENERATE_APPROVAL_PAGE_FORM_SUB_TITLE_FROM_APP = () =>
  "Create a page to manage workflow approvals.";
export const GENERATE_APPROVAL_PAGE_FORM_SUB_TITLE_FROM_WORKFLOW = () =>
  "Configure an application in this workspace to handle approval queries from this workflow.";
export const WORKFLOW_POST_DEPLOY_ACTION_GENERATE_APPROVAL_PAGE = () =>
  "Configure approval requests";
export const GENERATE_APPROVAL_PAGE_SELECT_APP_LABEL = () =>
  "Select your application";
export const GENERATE_APPROVAL_PAGE_SELECT_WORKFLOW_LABEL = () =>
  "Select your workflow";
export const GENERATE_APPROVAL_PAGE_ERROR_NO_QUERY = () =>
  "No approval requests found in the workflow";
export const GENERATE_APPROVAL_PAGE_MODAL_CTA_DISMISS = () => "I'll do later!";
export const GENERATE_APPROVAL_PAGE_ACTION_TITLE = () =>
  "Generate approvals page";
export const GENERATE_APPROVAL_PAGE_ERROR_NO_WORKFLOW = () =>
  "No workflows with approval requests found in the workspace";
// Workflows end

// AI begin
export const AI_RESPONSE_LOADING = () =>
  "your code is being generated, give it a few seconds";
export const AI_RECENT_PROMPTS = () => "Recent prompts";
export const AI_POPOVER_TITLE = () => "Appsmith's coding assistant";
export const AI_JS_EXPR_PLACEHOLDER = () =>
  "I can generate JavaScript code, Ask me something.";
export const AI_SQL_PLACEHOLDER = () =>
  "I can generate SQL queries, Ask me something.";
export const AI_JS_FUNC_PLACEHOLDER = () =>
  "I can complete JS Object functions, Ask me something.";
export const AI_USE_THIS_BUTTON_LABEL = () => "Use this";
export const AI_CONN_TIMEOUT_ERROR_MESSAGE = () =>
  "Connection timed out, its taking too long to generate code for you. Can you try again.";
export const AI_TOO_MANY_REQUESTS_ERROR_MESSAGE = () =>
  "Too many requests. You have already used 50 requests today. Please try again tomorrow or contact Appsmith team.";
export const AI_GENERATION_ERROR_MESSAGE = () =>
  "We can not generate a response for this prompt, to get accurate responses we need prompts to be more specific.";
export const AI_PROMPT_HELP_TEXT = () => "Press enter to send the prompt";
export const AI_PROMPT_EXAMPLE_PREFIX = () => "Example: ";
export const AI_INCORRECT_FEEDBACK_BUTTON_LABEL = () => "Incorrect response";
export const AI_DATASOURCE = () => "AI Datasource";
export const NEW_AI_AGENT = () => "AI Agent";
// AI end

// git START
export const GIT_CD_LICENSED_DESC = () =>
  "Automatically deploy updates to end users by triggering pulls from your preferred deployment tool.";
export const GIT_CD_ENABLED_TOAST = () =>
  "Continuous delivery configured successfully.";
export const GIT_CD_DISABLED_TOAST = () =>
  "Continuous delivery disabled successfully.";
export const GIT_CD_COPY_ENDPOINT = () => "Copy cURL";
export const GIT_CD_RECONFIGURE_API_KEY_CTA = () => "Re-configure bearer token";
export const GIT_CD_RECONFIGURE_API_KEY_DESC = () =>
  "Bearer token to authenticate requests";
export const GIT_CD_ENDPOINT_DESC = () => "cURL";
export const GIT_CD_API_KEY_WARNING = () =>
  "Paste your bearer token right away. You can't do this later.";
export const GIT_CD_COPY_API_KEY = () => "Copy bearer token";
export const GIT_CD_GENERATE_API_KEY_CTA = () => "Generate bearer token";
export const GIT_CD_GENERATE_API_KEY_DESC = () =>
  "Generate a bearer token to authenticate requests to the above endpoint";
export const GIT_CD_CONFIGURE_ENDPOINT_CD = () =>
  "Configure your pipeline to automatically call the below endpoint whenever modifications occur on the specified branch below.";
export const GIT_CD_FOLLOW_TO_CONFIGURE = () =>
  "Please follow these steps to configure...";
export const GIT_CD_SELECT_BRANCH_TO_CONFIGURE = () =>
  "Select a branch to configure";
export const GIT_CD_CONFIRM_CONFIGURATION = () =>
  "I've configured the pipeline in my deployment tool";
export const GIT_CD_FINISH_CONFIGURATION_CTA = () => "Finish setup";
export const GIT_CD_LAST_DEPLOYMENT = () => "Last deployment";
export const GIT_CD_DISABLE_CD = () => "Disable continuous delivery";
export const GIT_CD_DISABLE_CD_DESC = () =>
  "Disabling continuous delivery will stop automatic deployments to your end users, necessitating manual pull and deploy.";
export const GIT_CD_CONFIRM_DISABLE_CD = () => "I understand and confirm";
export const GIT_CD_RECONFIGURE_KEY_MODAL_TITLE = () =>
  "Re-configure bearer token";
export const GIT_CD_RECONFIGURE_KEY_MODAL_DESC = () =>
  "Regenerating your bearer token will invalidate the current key, leading to API failures. Please proceed with key regeneration only if you intend to replace your existing key on your deployment tool.";
export const GIT_CD_RECONFIGURE_KEY_MODAL_CTA = () =>
  "Re-configure bearer token";
// git END

// Seat based pricing start
export const ACCESS_CONTROL_USER_SEAT_INACTIVE = () =>
  "User seat inactive. Go to the License & plans tab to manage your plan.";
// Seat based pricing end

export const HEADER_TITLES = {
  ...CE_HEADER_TITLES,
  PACKAGE_EDITOR: () => "Package Editor",
  WORKFLOWS_EDITOR: () => "Workflows Editor",
};

export const EDITOR_PANE_TEXTS = {
  ...CE_EDITOR_PANE_TEXTS,
  query_modules_blank_state: () => "No query modules to display",
  js_modules_blank_state: () => "No JS modules to display",
  search_objects: {
    ...CE_EDITOR_PANE_TEXTS.search_objects,
    jsModules: () => "JS modules",
    queryModules: () => "Query modules",
  },
};

export const ORG_UPDATE_HEADER = () => `Hello, create your organisation`;
export const ORG_NAME_LABEL = () => `What’s your organisation name?`;
export const ORG_NAME_PLACEHOLDER = () => `Enter organisation name`;
export const ORG_SUB_DOMAIN_LABEL = () => `Subdomain for your organisation`;
export const ORG_SUB_DOMAIN_PLACEHOLDER = () => `subdomain`;
export const ORG_SUB_DOMAIN_POSTFIX = () => `.appsmith.com`;
export const ORG_SUB_DOMAIN_POSTFIX_FOR_AGENTS = () => `.appsmithai.com`;
export const ORG_UPDATE_NEXT_BUTTON = () => `Next`;
export const ORG_SUB_DOMAIN_AVAILABLE = () => `Subdomain available`;
export const ORG_SUB_DOMAIN_TAKEN = () => `Subdomain is not available`;
export const ORG_SUB_DOMAIN_CHECKING = () => `Checking...`;
export const ORG_UPDATE_ERROR = () => `Error updating organization`;
export const ORG_UPDATE_LICENSE_HEADER = () => `Choose a plan to get started`;
export const PER_MONTH_PER_USER = () => `/ month per user`;

// AI Agent
export const AI_AGENT_CREATE_DATASOURCE_AND_SEARCH_QUERIES_SUCCESS = () =>
  "Datasource and search queries created successfully";

export const AI_AGENT_CREATE_DATASOURCE_AND_SEARCH_QUERIES_ERROR = () =>
  "Error creating datasource and search queries";

export const CLOUD_BILLING_CHOOSE_PLAN_BUTTONS = {
  free: () => `Get started for free`,
  business: () => `Start 15-day free trial`,
  team: () => `Start 7-day free trial`,
  enterprise: () => `Book a meeting`,
};

// OAuth and SSO Error Messages
export const SAML_ALREADY_CONFIGURED = () =>
  "SAML configuration already exists. Please disconnect SAML before trying to configure it again";
export const UNABLE_TO_FIND_SAML_CONFIGURATION = () =>
  "Unable to find SAML configuration, please configure with identity provider to proceed.";
export const INVALID_SESSION_AUTH_REQUEST_NOT_FOUND = () =>
  "Invalid session. Authorisation request not found.";
export const INVALID_SESSION_REGISTRATION_ID_NOT_FOUND = () =>
  "Invalid session. Registration ID not found in the session.";

export const INVALID_AUTHORIZATION_TOKEN = () => "Invalid Authorization header";
export const INVALID_API_KEY = () => "Invalid Api Key";
export const API_KEY_NOT_MAPPED = () =>
  "Api Key not mapped. It may have already been disabled.";
export const API_KEY_ALREADY_EXISTS = () =>
  "Can't create a new API key. There already exists an API Key";
export const SEATS_UNAVAILABLE = () =>
  "Seats unavailable. Please reach out to the administrator to add more seats.";
